var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSupported(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.535,
    height: 221.428,
    viewBox: "0 0 209.535 221.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dae4f7;}.b{fill:url(#a);}.c{fill:#fff;}.d{fill:#7e9dae;}.e{fill:#e36465;}.f{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbe3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 126.493,
    y: 6.089,
    width: 83.043,
    height: 74.159,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f0b4b5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1844.767 952.675)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1871.133-846.489s-49-2.692-13.4-52.486,145.416-64.817,185.629-18.755-70.133,177.6-137.051,167.28C1844.766-759.943,1916.919-836.007,1871.133-846.489Z",
    transform: "translate(0 -4.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1984.461-503.487l40.594-40.594H1925.6l-41.12,41.12",
    transform: "translate(-21.551 -228.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2075.544-952.673h-94.836a2.538,2.538,0,0,0-2.538,2.538v173.743c0,2.149,1.136,3.891,2.538,3.891h94.836c1.4,0,2.538-1.742,2.538-3.891V-950.135A2.538,2.538,0,0,0,2075.544-952.673Z",
    transform: "translate(-74.578 -0.001)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 99.914,
    height: 5.319,
    transform: "translate(1903.59 -952.675)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 99.912,
    height: 19.98,
    transform: "translate(1903.592 -792.482)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.4,
    cy: 4.4,
    r: 4.4,
    transform: "translate(1980.893 -786.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.4,
    cy: 4.4,
    r: 4.4,
    transform: "translate(1949.147 -786.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.4,
    cy: 4.4,
    r: 4.4,
    transform: "translate(1917.401 -786.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2049.6-725.99l-.4.4-.384-.384Z",
    transform: "translate(-114.074 -126.726)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.828,
    height: 11.361,
    transform: "translate(1919.522 -934.622)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1980.259 -940.586)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -135.49, -12.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2175.369-920.182l-21.653,34.456A10.851,10.851,0,0,0,2162.9-869.1h43.305a10.852,10.852,0,0,0,9.188-16.625l-21.653-34.456A10.851,10.851,0,0,0,2175.369-920.182Z",
    transform: "translate(-2016.54 937.35)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.705 15.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2224.323-889.212a.71.71,0,0,1,.708.709v20.2a.71.71,0,0,1-.708.709h-4.216a.711.711,0,0,1-.709-.709v-20.2a.711.711,0,0,1,.709-.709Zm0,24.094a.71.71,0,0,1,.708.708v4.252a.71.71,0,0,1-.708.709h-4.216a.711.711,0,0,1-.709-.709v-4.252a.711.711,0,0,1,.709-.708Z",
    transform: "translate(-2219.399 889.212)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109.382 -107.899)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.476,
    cy: 4.476,
    r: 4.476,
    transform: "translate(2044.127 -756.753)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.476,
    cy: 4.476,
    r: 4.476,
    transform: "translate(2072.277 -756.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2082.89-719.6h-32.33a16.162,16.162,0,0,1,16.165-16.165A16.165,16.165,0,0,1,2082.89-719.6Z",
    transform: "translate(-3.886 -8.325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSupported);
export default __webpack_public_path__ + "static/media/not-supported.582acddcb8e53beecfa84606a783dc90.svg";
export { ForwardRef as ReactComponent };